'use client';

import { algoliaPDPTrackClickEvent } from '@libs/analytics';
import { useCartConfirmDrawer } from '@libs/shared-ui';

import { findProductsAddedToCart, type UseAddToCartOnSuccess } from '@/entities/cart';
import { useFulfilmentDrawerStore } from '@/features/fulfilment-selection';

import { useAddToCartAnalytics, useEEaddToCartAnalytics } from '../analytics';

export const useOnSuccessAddToCart = () => {
    const closeFulfilmentDrawer = useFulfilmentDrawerStore(state => state.close);
    const openCartDrawerWith = useCartConfirmDrawer(state => state.openWith);

    const { sendAnalytics } = useAddToCartAnalytics();
    const { sendAnalytics: sendEEAnalytics } = useEEaddToCartAnalytics();

    const onSuccess = ({ cart, payload, isProductRecommendation }: UseAddToCartOnSuccess) => {
        const productsAddedToCart = findProductsAddedToCart({ cart, payload });

        for (const productAddedToCart of productsAddedToCart) {
            algoliaPDPTrackClickEvent(productAddedToCart);
        }

        if (productsAddedToCart.length) {
            closeFulfilmentDrawer();
            openCartDrawerWith(productsAddedToCart);
            sendAnalytics(isProductRecommendation);
            sendEEAnalytics();
        }
    };

    return { onSuccess };
};
